import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  initOmniState,
  searchFpJsonData,
  saveFpJsonData,
  changeOmniState,
  omniSearchSignatureData,
  omniSaveSignBothData,
  jsonDataToXml,
  registerReportToJoblist,
  loadEaDocDataJson,
} from '@store/actions/omniAction';
import { initEaState, getEaPlanDetail } from '@store/actions/eaAction';
import { searchSubscription } from '@store/actions/appListAction';
import AppReportLnb from '@components/appList/AppReportLnb';
import OmniPlanInfoMain from '@container/omni/OmniPlanInfoMain';
import UnderwritingMemo from '@container/omni/UnderwritingMemo';
import AppReportInterview from '@components/appList/AppReportInterview';
import OmniCheckListMain from '@container/omni/OmniCheckListMain';
import AppReportCustomerCheck from '@components/appList/AppReportCustomerCheck';
import LifePlannerSignPopup from '@components/common/biz/LifePlannerSignPopup';
import FpInterviewMain from '@container/appList/FpInterviewMain';
import SatModal from '@components/common/satUI/SatModal';
import SatButton from '@components/common/satUI/SatButton';
import { toast } from 'react-toastify';
import { checkSuitabilityPlan } from '@common/utils';
import { NBS_BIZ_CODE_INFO } from '@common/constants';

const AppReportMain = props => {
  const {
    applicationNo,
    subscriptionDate,
    setBizModal,
    omniYn,
    isRepublish,
    policyNo,
    planEstablishNo,
    handleReSearch,
  } = props;

  const dispatch = useDispatch();
  const { changeOrientation } = $hooks.useDevice();
  const { error: toastError } = $hooks.useToast();
  const { alert } = $hooks.useModal();
  const {
    saveEaToNbs,
    eaJsonData,
    getSharedPlanInfoList,
    searchSubscriptionSharedLpList,
  } = $hooks.useApi();
  const { checkUrlExist } = $hooks.useUtil();
  const { eaReducer, omniReducer, userReducer } = useSelector(state => state);
  const { userInfo, channelInfo } = userReducer;
  const { planMainInfo, checkListYn, contractSign } = eaReducer;
  const { appCompletePage, fpReport, appIsContinue, signData, isContinue } =
    omniReducer;

  const isLP = $utils.checkLP(channelInfo.cdVal);
  const [isCheckList, setIsCheckList] = useState(true);
  const [title1Status, setTitle1Status] = useState(false);
  const [title2Status, setTitle2Status] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [isClosePopup, setIsClosePopup] = useState(false);
  const [isNotComplete, setIsNotComplete] = useState(false);
  const [isShowSighPopup, setIsShowSighPopup] = useState(''); // 서명팝업 노출 여부

  const isMinor = useMemo(
    () => isLP && Number(planMainInfo?.ownerPrspInfo?.legalAge) < 19,
    [planMainInfo],
  ); // 미성년 여부

  // 보고서작성 닫기
  const handleCloseBtnClick = () => {
    setIsClosePopup(true);
  };

  // 보고서작성 닫기 버튼 팝업 확인 버튼
  const handleCloseConfirmBtn = () => {
    setIsClosePopup(false);
    dispatch(changeOmniState({ type: 'appIsContinue', data: true }));
    dispatch(
      saveFpJsonData({
        applicationNo: applicationNo,
        callback: saveJsonCallBack,
      }),
    );
  };

  // 저장완료 후 보고서작성 닫기
  const saveJsonCallBack = type => {
    if (type) {
      dispatch(initEaState());
      dispatch(initOmniState());
      setBizModal({ visible: false });
      changeOrientation('landscape'); // 가로 전환
      handleReSearch();
      // Robin: 모바일 등 외부에서 팝업을 연 경우를 위해 팝업 닫힘 메시지 전달
      $utils.sendMessageToParent({ type: 'closePopup' }, '*');
    }
  };

  // 다음 클릭
  const handleNextClick = () => {
    setCurrentPage(currentPage + 1);
  };

  // 각자 페이지 확인 버튼
  const handleConfirmBtnClick = type => {
    if (type === 'lastPage') {
      handleIsSignCheck();
    } else {
      setCurrentPage(currentPage + 1);
    }
    const completePages = [...appCompletePage, currentPage];
    dispatch(
      changeOmniState({
        type: 'appCompletePage',
        data: [...new Set(completePages)],
      }),
    );
    dispatch(
      saveFpJsonData({
        applicationNo: applicationNo,
        // callback: callbackConfirmBtn(),
      }),
    );
  };

  // fpReport 리듀서 변경
  const hanldeFpReportChange = (object, target, value) => {
    // 모집경로 수정
    if (object === 'recruitment') {
      if (target === 'moPath' && value !== '소개') {
        hanldeFpReportData(
          {
            moType: '',
            moPath: value,
          },
          object,
        );
      } else if (target === 'moType' && fpReport[object].moPath !== '소개') {
        hanldeFpReportData(
          {
            moType: value,
            moPath: '소개',
          },
          object,
        );
      } else {
        hanldeFpReportData(
          {
            ...fpReport[object],
            [target]: value,
          },
          object,
        );
      }
    }

    if (object === 'satLpReport') {
      // SNS 경로 수정
      if (target === 'useSns') {
        hanldeSatLpReportData({
          sns: {
            snsType: value ? fpReport.satLpReport.sns.snsType : '',
            useSns: value,
          },
        });
      } else if (target === 'snsType') {
        hanldeSatLpReportData({
          sns: { useSns: fpReport.satLpReport.sns.useSns, snsType: value },
        });
        // 보험가입동기 복수선택
      } else if (target === 'joinMotivation') {
        hanldeSatLpReportData({
          joinMotivation: value.map(data => data.value),
        });
        // Activity 진행횟수
      } else if (target === 'activityAp') {
        hanldeSatLpReportData({
          activity: { ap: value, pr: fpReport.satLpReport.activity.pr },
        });
      } else if (target === 'activityPr') {
        hanldeSatLpReportData({
          activity: { pr: value, ap: fpReport.satLpReport.activity.ap },
        });
        // 가족 구성
      } else if (target === 'marriage') {
        hanldeSatLpReportData({
          family: {
            marriage: value,
            child: value ? fpReport.satLpReport.family.child : '',
          },
        });
      } else if (target === 'child') {
        hanldeSatLpReportData({
          family: {
            marriage: fpReport.satLpReport.family.marriage,
            child: value,
          },
        });
      } else {
        hanldeSatLpReportData({ [target]: value });
      }
    }

    if (object === 'interview') {
      hanldeFpReportData(
        {
          owner: {
            ...fpReport.interview.owner,
            [target]: value,
          },
        },
        object,
      );
    }
  };

  //fpReport 상태변경
  const hanldeFpReportData = (data, target) => {
    dispatch(
      changeOmniState({
        type: 'fpReport',
        data: {
          ...fpReport,
          [target]: { ...fpReport[target], ...data },
        },
      }),
    );
  };

  //lpReport 상태변경
  const hanldeSatLpReportData = data => {
    dispatch(
      changeOmniState({
        type: 'fpReport',
        data: {
          ...fpReport,
          satLpReport: { ...fpReport.satLpReport, ...data },
        },
      }),
    );
  };

  // 모든페이지가 작성완료 됬는지 체크 작성완료 되면 보험설계사서명 팝업
  const handleIsSignCheck = () => {
    if (isLP) {
      if (isCheckList) {
        if (
          appCompletePage.includes(1) &&
          appCompletePage.includes(2) &&
          appCompletePage.includes(3)
        ) {
          setIsShowSighPopup(true);
        } else {
          setIsNotComplete(true);
        }
      } else {
        if (appCompletePage.includes(1) && appCompletePage.includes(2)) {
          setIsShowSighPopup(true);
        } else {
          setIsNotComplete(true);
        }
      }
    } else {
      if (isCheckList) {
        if (
          appCompletePage.includes(1) &&
          appCompletePage.includes(2) &&
          appCompletePage.includes(3) &&
          appCompletePage.includes(4)
        ) {
          setIsShowSighPopup(true);
        } else {
          setIsNotComplete(true);
        }
      } else {
        if (
          appCompletePage.includes(1) &&
          appCompletePage.includes(2) &&
          appCompletePage.includes(3)
        ) {
          setIsShowSighPopup(true);
        } else {
          setIsNotComplete(true);
        }
      }
    }
  };

  // 전자 서명 조회
  const handleSearchSignData = () => {
    dispatch(omniSearchSignatureData({ empNumber: userInfo.userId }));
  };

  // 전자청약(type: 1)용 DOC_DATA_JSON 조회
  const getEaDocDataJson = async applicationNo => {
    try {
      const formData = new FormData();
      formData.append('tranMode', 'Q');
      formData.append('publishNumber', applicationNo);
      formData.append('docType', '1');
      const response = await eaJsonData({ payload: formData });
      const data = $utils.getApiData(response);
      const isSuccess =
        $utils.checkApiSuccess(response) && $utils.checkOmnSuccess(response);
      if (!isSuccess) throw new Error('전자청약 docDataJson API 실패');

      const parsingJsonData = JSON.parse(data.docDataJson);
      return parsingJsonData;
    } catch (error) {
      console.log('getEaDocDataJson() - error', error);
      throw new Error('전자청약 docDataJson 불러오기 실패');
    }
  };

  const getSharedPlanAgents = async () => {
    try {
      // 공동청약 필요한 데이터가 두 API로 나누어져 있어 둘 다 호출 후 조합하여 사용
      const sharedPlanResponses = await Promise.all([
        searchSubscriptionSharedLpList({ params: { planEstablishNo } }),
        getSharedPlanInfoList({ params: { policyNo } }),
      ]);

      const [data1, data2] = sharedPlanResponses.map(response =>
        $utils.getApiData(response),
      );
      const isSuccess = sharedPlanResponses.every(response =>
        $utils.checkApiSuccess(response),
      );
      if (!isSuccess) throw new Error('공동청약 정보 조회 API 실패');

      const sharedPlanAgents = $utils.mergeSharedPlans(data1, data2);

      return sharedPlanAgents;
    } catch (error) {
      console.log('getSharedPlanAgents() - error', error);
      throw new Error('공동청약 정보 조회 실패');
    }
  };

  // 설계사 보고서 완료 시, 신계약에 청약/보고서 내용 저장하는 함수
  const handleSaveFpToNbs = async () => {
    try {
      // 공동 청약 여부
      const isSharedPlan = planMainInfo?.jointApplicationYn === 'Y';

      // OMN_PROGRESS_MSTS 에 있는 전자청약(type: 1)용 DOC_DATA_JSON 조회
      const eaDocDataJson = await getEaDocDataJson(applicationNo);
      const sharedPlanAgents = isSharedPlan ? await getSharedPlanAgents() : [];
      const fpDocDataJson = $utils.makeFpDocDataJson(true);
      const nbsPayload = $utils.getSaveFpToNbsPayload(
        eaDocDataJson,
        fpDocDataJson,
        sharedPlanAgents,
      );

      const payload = {
        ...nbsPayload,

        omniYn: 'N', // 청약진행업무구분코드 (옴니(Y)/전자청약(N))
        applNo: applicationNo, // 발행번호
        applReqBzTpCd: NBS_BIZ_CODE_INFO.fpReport, // 청약요청업무구분코드
      };

      const response = await saveEaToNbs({ payload });
      const isSuccess = $utils.checkApiSuccess(response);
      if (!isSuccess) throw new Error('신계약 청약 저장 API 실패');

      // API 성공 한 경우, 진행 가능여부 체크 및 보여줄 메시지 확인
      const isNbsSuccess = $utils.checkNbsSuccess(response);
      const message = $utils.getNbsMessage(response);

      // 보여줄 메시지가 있을 경우 노출
      if (message) {
        await new Promise(resolve => alert({ message, onClose: resolve }));
      }

      // 만약 신계약에서 API 결과가 성공으로 내려오지 않았는데,
      // 보여줄 메시지도 안내려왔다면 커스텀 오류 메시지 노출
      else if (!isNbsSuccess)
        toastError(
          '청약 저장 결과가 정상적이지 않습니다.\n다음에 다시 시도해주세요.',
        );

      return isNbsSuccess;
    } catch (error) {
      console.log('handleSaveFpToNbs() - error', error);
      toastError('청약 저장에 실패하였습니다.');
      return false;
    }
  };

  const handleSaveSign = (signNameData, signatureData) => {
    return new Promise(resolve => {
      dispatch(
        omniSaveSignBothData({
          signNameData: signNameData,
          signatureData: signatureData,
          empNumber: userInfo.userId,
          callback: resolve,
        }),
      );
    });
  };

  // 보고서작성 완료 후 청약서 맵핑 xml 생성
  const handleAppListUpdate = () => {
    return new Promise(resolve => {
      dispatch(
        jsonDataToXml({
          applicationNo: applicationNo,
          schedulerType: 'ETC',
          isCheckList: isCheckList,
          isRepublish: isRepublish,
          omniYn: omniYn,
          reportDate: contractSign
            .find(a => 517 === a.step)
            ?.newContract?.list2?.replaceAll('-', ''),
          callback: resolve,
        }),
      );
    });
  };

  // 청약서 맵핑 성공 후 보고서 데몬에 등록 요청
  const registerToJoblist = () => {
    dispatch(
      registerReportToJoblist({
        applicationNo: applicationNo,
        isOmni: omniYn === 'Y',
        callback: reportDemonCallback,
      }),
    );

    // LP 보고서 작성시 대면 정보 전송 안하는 걸로 변경
    // if (omniYn === 'Y') {
    //   // 옴니 일 경우 만 대면 보고서 작성
    //   dispatch(registerInterviewToJoblist({ applicationNo: applicationNo }));
    // }
  };

  // 데몬이 보고서 확인 요청 후 보고서 팝업 닫기, 청약목록 재조회
  const reportDemonCallback = type => {
    if (type) {
      toast(
        <div>
          보고서 작성이 완료되었습니다.
          <br />
          이체가 진행됩니다.
          <br />
          {`${
            !$utils.checkGA(channelInfo.cdVal) ? `SM/AM 확인 완료 후 ` : ``
          }심사 진행됩니다.`}
        </div>,
      );

      dispatch(searchSubscription({ policyNo: policyNo }));
      setBizModal({ visible: false });
    }
  };

  // 전자 서명 저장 - 전자청약 설계사 보고서 완료
  const handleOnSave = async (signNameData, signatureData) => {
    try {
      // 신계약 청약 저장 API 전송 후 다음으로 이동
      const isNextAvailable = await handleSaveFpToNbs();
      if (!isNextAvailable) return;

      // 보험설계사 서명 저장
      const isSuccessSaveSign = await handleSaveSign(
        signNameData,
        signatureData,
      );
      if (!isSuccessSaveSign) return;

      // 설계사 보고서 PDF/XML 생성
      const { schedulerInfo = [] } = await handleAppListUpdate();

      // 설계사 보고서 PDF 제대로 생성 되었는지 확인
      const fpReportPdfInfo = schedulerInfo.find(
        ({ docType }) => docType === '2',
      );
      const fpReportPdfUrl = fpReportPdfInfo?.pdfPath;
      const isPdfAvailable = await checkUrlExist(fpReportPdfUrl);
      if (!isPdfAvailable)
        return alert({ message: 'PDF 생성에 실패하였습니다.' });

      // 데몬에 보고서 등록
      registerToJoblist();

      // 서명 팝업 닫기
      setIsShowSighPopup(false);
    } catch (error) {
      console.log('handleOnSave() - error', error);
      toastError('청약 저장 중 에러가 발생하였습니다.');
    }
  };

  const loadData = async () => {
    dispatch(initOmniState());
    dispatch(initEaState());
    dispatch(
      searchFpJsonData({
        applicationNo: applicationNo,
      }),
    );

    // 청약 시 DocDataJson 조회
    const eaDocDataJson = await getEaDocDataJson(applicationNo);
    dispatch(loadEaDocDataJson(eaDocDataJson));
  };

  useEffect(loadData, [applicationNo]);

  useEffect(() => {
    // plan 상세조회
    dispatch(
      getEaPlanDetail({
        planEstablishNo: planEstablishNo,
        appReport: true,
      }),
    );
  }, [planEstablishNo]);

  // 정기성 보험, 어린이 보험 월보험료 5만원 이하 체크
  useEffect(() => {
    setIsCheckList(checkListYn === 'Y');

    // const mainProductCode = planMainInfo.mainProductCode.substring(0, 4);
    // const { payinMethod, premium, currencyUsdYN } = planMainInfo;
    // if (
    //   mainProductCode === '3031' ||
    //   mainProductCode === '3070' ||
    //   mainProductCode === '3110' ||
    //   mainProductCode === '3151' ||
    //   mainProductCode === '3152' ||
    //   mainProductCode === '3251' ||
    //   mainProductCode === '3252' ||
    //   mainProductCode === '6030'
    // ) {
    //   setIsCheckList(false);
    // } else {
    //   if (currencyUsdYN === 'Y') {
    //     if (payinMethod === '3') {
    //       premium * 1500 <= 50000
    //         ? setIsCheckList(false)
    //         : setIsCheckList(true);
    //     } else if (payinMethod === '4') {
    //       (premium * 1500) % 3 <= 50000
    //         ? setIsCheckList(false)
    //         : setIsCheckList(true);
    //     } else if (payinMethod === '5') {
    //       (premium * 1500) % 6 <= 50000
    //         ? setIsCheckList(false)
    //         : setIsCheckList(true);
    //     } else if (payinMethod === '6') {
    //       (premium * 1500) % 12 <= 50000
    //         ? setIsCheckList(false)
    //         : setIsCheckList(true);
    //     } else {
    //       // 일시납 payinMethod === '8'
    //       setIsCheckList(true);
    //     }
    //   } else {
    //     if (payinMethod === '3') {
    //       premium <= 50000 ? setIsCheckList(false) : setIsCheckList(true);
    //     } else if (payinMethod === '4') {
    //       premium % 3 <= 50000 ? setIsCheckList(false) : setIsCheckList(true);
    //     } else if (payinMethod === '5') {
    //       premium % 6 <= 50000 ? setIsCheckList(false) : setIsCheckList(true);
    //     } else if (payinMethod === '6') {
    //       premium % 12 <= 50000 ? setIsCheckList(false) : setIsCheckList(true);
    //     } else {
    //       // 일시납 payinMethod === '8'
    //       setIsCheckList(true);
    //     }
    //   }
    // }
  }, [checkListYn]);

  // 현재 페이지별 LNB 단계 상태값
  useEffect(() => {
    if ($utils.checkLP(channelInfo.cdVal)) {
      if (currentPage > 0 && currentPage < 4) {
        setTitle1Status(true);
        setTitle2Status(false);
      }
      if (isCheckList && currentPage === 4) {
        setTitle1Status(false);
        setTitle2Status(true);
      }
    } else {
      if (currentPage > 0 && currentPage < 5) {
        setTitle1Status(true);
        setTitle2Status(false);
      }
      if (isCheckList && currentPage === 5) {
        setTitle1Status(false);
        setTitle2Status(true);
      }
    }
  }, [currentPage, channelInfo]);

  // 기존 완료된 페이지 체크
  useEffect(() => {
    if (appCompletePage.length > 0) {
      const maxCurrentPage = Math.max(...appCompletePage);
      if (appIsContinue && currentPage < maxCurrentPage) {
        toast('보고서 작성을 이어서 진행합니다. 입력정보를 확인하세요.');
        setCurrentPage(maxCurrentPage);
      }
    } else {
      setCurrentPage(0);
    }
  }, [appIsContinue]);

  return (
    <div className="container">
      <AppReportLnb
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        planMainInfo={planMainInfo}
        title1Status={title1Status}
        setTitle1Status={setTitle1Status}
        title2Status={title2Status}
        setTitle2Status={setTitle2Status}
        isCheckList={isCheckList}
        type={channelInfo.cmnCdNm}
        completePage={appCompletePage}
        onClickCloseBtn={handleCloseBtnClick}
        isMinor={isMinor}
      />
      <div className="content">
        {currentPage === 0 && (
          // 설계내용
          <OmniPlanInfoMain
            planMainInfo={planMainInfo}
            onClickNext={handleNextClick}
          />
        )}
        {currentPage === 1 && (
          // 계약자실명증표 (계약자가 미성년자가 아닌 경우만 노출)
          // -> 계약자가 미성년자도 노출되게 수정..
          <AppReportCustomerCheck
            userType={channelInfo.cmnCdNm}
            fpReport={fpReport}
            onChangeFpReport={hanldeFpReportData}
            onClickNext={handleConfirmBtnClick}
            omniYn={omniYn}
            applicationNo={applicationNo}
            isMinor={isMinor}
          />
        )}
        {currentPage === 2 && (
          // 심사 참고사항
          <UnderwritingMemo
            planMainInfo={planMainInfo}
            applicationNo={applicationNo}
            onClickNext={handleNextClick}
            completePage={appCompletePage}
            currentPage={currentPage}
            isAppList={true}
            userInfo={channelInfo}
          />
        )}
        {currentPage === 3 && (
          // 모집경로 및 면담정보
          <AppReportInterview
            onClickConfirmBtn={handleConfirmBtnClick}
            fpReport={fpReport}
            subscriptionDate={subscriptionDate}
            onChangeFpReport={hanldeFpReportChange}
            ownerName={planMainInfo.ownerPrspInfo.name}
            complete={appCompletePage.includes(3) || isContinue}
            isCheckList={isCheckList}
            userType={channelInfo.cmnCdNm}
            omniYn={omniYn}
          />
        )}
        {currentPage === 4 && isLP && (
          // 판매체크리스트
          <OmniCheckListMain
            onClickNext={handleIsSignCheck}
            owner={planMainInfo.ownerPrspInfo}
            applicationNo={applicationNo}
            completePage={appCompletePage}
            fpReport={fpReport}
            checkList={fpReport.checkList}
            currentPage={currentPage}
            isAppList={true}
            planEstablishProduct={planMainInfo.planEstablishProduct}
            isVariableProduct={checkSuitabilityPlan(planMainInfo)}
            contractSign={contractSign.find(a => 517 === a.step)}
          />
        )}
        {currentPage === 4 && !isLP && (
          // 면담정보
          <FpInterviewMain
            fpReport={fpReport}
            planMainInfo={planMainInfo}
            completePage={appCompletePage}
            currentPage={currentPage}
            applicationNo={applicationNo}
            onClickConfirmBtn={handleConfirmBtnClick}
            isCheckList={isCheckList}
            omniYn={omniYn}
          />
        )}
        {currentPage === 5 && !isLP && (
          // 판매체크리스트
          <OmniCheckListMain
            onClickNext={handleIsSignCheck}
            owner={planMainInfo.ownerPrspInfo}
            applicationNo={applicationNo}
            completePage={appCompletePage}
            fpReport={fpReport}
            checkList={fpReport.checkList}
            currentPage={currentPage}
            isAppList={true}
            planEstablishProduct={planMainInfo.planEstablishProduct}
            isVariableProduct={checkSuitabilityPlan(planMainInfo)}
            contractSign={contractSign.find(a => 517 === a.step)}
          />
        )}
      </div>

      <SatModal
        visible={isClosePopup}
        setVisible={() => {
          setIsClosePopup(false);
        }}
        type="confirm"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text info text-center">
                  {`보고서 작성을 종료하시겠어요? 지금까지 작성한 내용은 자동 저장됩니다.`}
                </p>
              </div>
              <div className="btn-group">
                <SatButton
                  styleClass="btn-half cancel"
                  label={'취소'}
                  onClick={() => setIsClosePopup(false)}
                />
                <SatButton
                  styleClass="btn-half confirm"
                  label={'확인'}
                  onClick={() => handleCloseConfirmBtn()}
                />
              </div>
            </>
          );
        }}
      />

      <SatModal
        visible={isNotComplete}
        setVisible={() => {
          setIsNotComplete(false);
        }}
        type="info"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text info text-center">
                  {isLP
                    ? '라이프파트너 서명은 이전 단계들이 모두 완료되어야 진행할 수 있습니다.'
                    : '보험설계사 서명은 이전 단계들이 모두 완료되어야 진행할 수 있습니다.'}
                </p>
              </div>
              <div className="layer-footer">
                <SatButton
                  styleClass="btn-s blue btn-wide"
                  label={'확인'}
                  onClick={() => setIsNotComplete(false)}
                />
              </div>
            </>
          );
        }}
      />

      <SatModal
        visible={isShowSighPopup}
        type="info"
        wide
        setVisible={() => {
          setIsShowSighPopup(false);
        }}
        isNotification={true}
      >
        {/* 보험설계사 서명 */}
        <LifePlannerSignPopup
          searchSignData={handleSearchSignData}
          ownerName={planMainInfo.ownerPrspInfo.name}
          applicationNo={applicationNo}
          onClose={() => setIsShowSighPopup(false)}
          signData={signData.lpSignInfo}
          complete={false}
          empName={userInfo.username}
          onSave={handleOnSave}
          isShowContractName={!isLP && omniYn === 'Y'} // hanjy: 보고서 작성시 보험설계사 서명에서 고객 이름 입력
          userType={channelInfo.cmnCdNm}
          lpDeptYn={channelInfo.lpDeptYn}
        />
      </SatModal>
    </div>
  );
};

export default AppReportMain;
